import { STXR_PROTOCOL_VERSION } from "../constants/stxr";

export const STYX_THEME = {
  appName: "НУЛЬМОД",
  stxrProtocolVersion: STXR_PROTOCOL_VERSION,
  encryptionBanner: "STXR ENCRYPTED // crypto_box_easy // X25519",
  matrixGlyphs: "ｱｲｳｴｵｶｷｸｹｺSTXR0123456789",
  bootSteps: [
    "libsodium",
    "key vault",
    "stxr tables",
    "relay",
    "challenge auth",
  ],
} as const;

export type PresenceStatus = "online" | "offline" | "typing" | "idle";
